import React from 'react';
import { CheckCircle, Clock, MapPin, Shield } from 'lucide-react';

export const TrustStrip = () => {
  const trustItems = [
    { icon: CheckCircle, text: 'Free Quotes' },
    { icon: Clock, text: 'Fast Response' },
    { icon: MapPin, text: 'Greater Sydney' },
    { icon: Shield, text: '24/7 Emergency' },
  ];

  return (
    <section className="bg-primary py-4" data-testid="trust-strip">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12">
          {trustItems.map((item, index) => (
            <div key={index} className="flex items-center space-x-2 text-white">
              <item.icon className="w-5 h-5" />
              <span className="font-medium text-sm md:text-base">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
